export const supportedLocales = {
  en: 'English',
  zh: '中文',
  ko: '한국어',
  ja: '日本語',
};

export const LAST_LANGUAGE_LOCAL_STORAGE_KEY = 'bridge/last-language';
